import { Edit } from 'react-admin';
import { ScheduleForm } from './Schedule.Form';

export const ScheduleEdit = () => {
    return (
        <Edit>
            <ScheduleForm />
        </Edit>
    );
};
